import { RegimeAccessChanged } from "event-definitions"
import { getStoreState, setStoreState } from "lib/store"
import { gql } from "@apollo/client"
import { getApolloClient } from "lib/graphql/client"

const STORE_KEY_PREFIX = "regimeLock"
const GET_IS_UNLOCKED_QUERY = gql`
    query GetIsUnlocked($regimeId: String!) {
        getIsUnlocked(regimeId: $regimeId)
    }
`

export function updateRegimeLock(regimeId, isUnlocked) {
    if (!regimeId) {
        return
    }
    const previous = getRegimeLock(regimeId)
    setStoreState(`${STORE_KEY_PREFIX}.${regimeId}`, () => isUnlocked)
    if (isUnlocked !== undefined) {
        getApolloClient().cache.writeQuery({
            query: GET_IS_UNLOCKED_QUERY,
            variables: { regimeId },
            data: { getIsUnlocked: isUnlocked },
        })
    }
    if (previous !== isUnlocked) {
        RegimeAccessChanged.raise({ regimeId, isUnlocked })
    }
}

export function getRegimeLock(regimeId) {
    if (!regimeId) {
        return undefined
    }
    return getStoreState(`${STORE_KEY_PREFIX}.${regimeId}`)
}
